import { render, staticRenderFns } from "./Prices.vue?vue&type=template&id=7266d770&scoped=true"
import script from "./Prices.vue?vue&type=script&lang=js"
export * from "./Prices.vue?vue&type=script&lang=js"
import style0 from "./Prices.vue?vue&type=style&index=0&id=7266d770&prod&lang=css"
import style1 from "./Prices.vue?vue&type=style&index=1&id=7266d770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7266d770",
  null
  
)

export default component.exports